import React, { useState } from "react";
import IconButton from "../../../share/buttons/IconButton";
import Card from "../../../share/cards/Card";
import { ReactComponent as Trash } from "../../../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../../../Assets/Image/svg/edit.svg";
import EmptyCourseDash from "../../../share/EmptyCourseDash/EmptyCourseDash";
import { Modal } from "../../../share/modal/Modal";
import { BsArrowLeft } from "react-icons/bs";
import { BtnPrimary } from "../../../share/buttons/Btn";
import { BsArrowRight } from "react-icons/bs";
import { ReactComponent as TicketDot } from "../../../../Assets/Image/svg/ticketDot.svg";
import DiscountInfo from "./DiscountInfo";
import useFetch from "../../../../Hooks/useFetch";
import { useCreate } from "../../../../Context/CreateContext";
import MainPagination from "../../../share/Pageination/MainPagination";

const CreateCourseDiscount = (props) => {
    const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

    const [emptyPage, setEmptyPage] = useState(false);
    const [upload, setUpload] = useState(false);
    const [discount, setDiscount] = useState();
    const [del, setDel] = useState();
    const [edit, setEdit] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const handleModal = () => {
        setUpload((prev) => !prev);
    };
    const handlePage = () => {
        setEmptyPage((prev) => !prev);
    };

    const handleDelete = (id) => {
        setDel(id);
        deleteDiscount.reFetch();
    };
    const handleEdit = (id) => {
        setEdit(id);
        setUpload((prev) => !prev);
    };

    //
    const getDiscount = useFetch({
        method: "GET",
        url: `DiscountService/${bootCamp.id}/discounts`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setDiscount,
    });

    const deleteDiscount = useFetch({
        method: "DELETE",
        url: `DiscountService/${del}`,
        noHeader: false,
        caller: getDiscount,
    });

    return (
        <div className=" mt-20">
            {discount?.results.length !== 0 ? (
                <>
                    <div className="flex justify-between items-center mb-20">
                        <h4 className="text-[2rem] text-purple-dark font-bold">
                            اطلاعات کد‌های تخفیف بوت کمپ
                        </h4>
                        <BtnPrimary
                            text="+ ساخت کد تخفیف جدید"
                            className="px-16 py-7"
                            onClick={() => handleModal()}
                        />
                    </div>
                    <Card className="SupportTicketTable-card SupportTicketTable-body  my-4 font-bold text-black-prim">
                        <div>نام تخفیف</div>
                        <div>درصد/مبلغ تخفیف</div>
                        <div>نام کد</div>
                        <div></div>
                    </Card>
                    {discount?.results.map((i) => (
                        <Card
                            key={i.id}
                            className="SupportTicketTable-card SupportTicketTable-body  my-4 relative"
                        >
                            <div className=" absolute top-[31px] right-0">
                                <TicketDot />
                            </div>
                            <div className=" text-black-prim">
                                {i.discount_name}
                            </div>
                            <div>
                                {i.discount_percentage && (
                                    <div>{i.discount_percentage} %</div>
                                )}
                                {i.discount_amount && (
                                    <div>{i.discount_amount} تومان</div>
                                )}
                            </div>
                            <div className=" text-purple-dark cursor-pointer">
                                {i.discount_coupon_password}
                            </div>
                            <div className="">
                                {!i.checked && (
                                    <div className="flex justify-end">
                                        <IconButton
                                            data-tip="حذف"
                                            onClick={() => handleDelete(i.id)}
                                        >
                                            <Trash />
                                        </IconButton>
                                        <IconButton
                                            data-tip="ویرایش"
                                            onClick={() => handleEdit(i.id)}
                                        >
                                            <Edit />
                                        </IconButton>
                                    </div>
                                )}
                            </div>
                        </Card>
                    ))}
                    <MainPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        data={discount?.results}
                        pageSize={discount?.page_count}
                        className="mt-[3rem]"
                    />
                    <div className="flex  justify-between items-center mt-20">
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.prevStep}
                        >
                            <BsArrowRight />
                            <span>مرحله قبل</span>
                        </div>
                        <div
                            className="w-[20%] py-[15px] px-[35px] flex border-purple-dark text-purple-dark border-[1px] text-[1.8rem] rounded-[1.5rem] justify-around items-center cursor-pointer"
                            onClick={props.nextStep}
                        >
                            <span>ثبت و ادامه</span>
                            <BsArrowLeft />
                        </div>
                    </div>
                    <Modal show={upload} closeModal={handleModal}>
                        <DiscountInfo
                            getDiscounts={getDiscount}
                            edit={edit}
                            setEdit={setEdit}
                            close={handleModal}
                        />
                    </Modal>
                </>
            ) : (
                <>
                    <EmptyCourseDash name="تخفیف" show={setEmptyPage} />

                    <Modal show={emptyPage} closeModal={handlePage}>
                        <DiscountInfo close={handlePage} />
                    </Modal>
                </>
            )}
        </div>
    );
};

export default CreateCourseDiscount;
